import { fromPromise } from 'xstate';
/**
 * 파일 업로드 액터의 Promise 로직을 생성하는 팩토리 함수.
 * @param fileService 파일 업로드 로직을 수행할 서비스 인스턴스
 * @returns XState 액터에서 사용할 Promise 로직
 */
export const createUploadFileActorLogic = (fileService) => {
    return fromPromise(async ({ input }) => {
        // 주입받은 fileService 사용
        return fileService.uploadFile(input);
    });
};
/**
 * 인증 액터의 Promise 로직 (authService 의존성 추가)
 * @param authService 인증 로직을 수행할 서비스 인스턴스
 * @returns XState 액터에서 사용할 Promise 로직
 */
export const createAuthorizeActorLogic = (authService) => {
    return fromPromise(async ({ input }) => {
        console.log('[Actor authorize] Attempting login with input:', input);
        // 주입받은 authService 사용
        try {
            const result = await authService.login(input);
            console.log('[Actor authorize] Login successful:', result.token);
            return result;
        }
        catch (error) {
            console.error('[Actor authorize] Login failed:', error);
            // 오류를 다시 throw하여 XState 머신의 onError 트랜지션에서 처리하도록 함
            throw error;
        }
    });
};
